import React from 'react';
import styled from 'styled-components';

import {
  Colors,
  FontFamilies,
  FontSizes,
  Theme,
} from 'common';

import {
  Text
} from './text/index';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
`;

const ToggleLabel = styled(Text)`
  font-size: ${FontSizes.Small};
  font-family: ${FontFamilies.Regular};
  color: ${Theme.Text.Color || '#2c3e50'};
`;

const ToggleSwitch = styled.div`
  width: 40px;
  height: 20px;
  background-color: ${props => props.active ? (Colors.PrimaryOne || '#3498db') : '#95a5a6'};
  border-radius: 10px;
  position: relative;
  transition: background-color 0.3s;
  
  &::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: white;
    top: 2px;
    left: ${props => props.active ? '22px' : '2px'};
    transition: left 0.3s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

export const Toggle = ({ 
  label, 
  active, 
  onChange, 
  ...props 
}) => {
  return (
    <ToggleContainer onClick={onChange} {...props}>
      {label && <ToggleLabel>{label}</ToggleLabel>}
      <ToggleSwitch active={active} />
    </ToggleContainer>
  );
};
